import { cashdeskPagePlayersModel } from 'pages/cashdesk-page/model';
import { createPlayerRegistry } from 'entities/player';
import cls from './cashdesk-page-players.module.scss';

const PlayerRegistry = createPlayerRegistry(cashdeskPagePlayersModel.playerRegistryModel);

export const CashdeskPagePlayers = () => (
	<PlayerRegistry
		withTitle={false}
		withAccount={false}
		withCashdesk={false}
		withCashdeskFilter={false}
		className={cls.cashdeskPagePlayersRegistry}
	/>
);
